import { render } from "./TestInstructionsStepOne.vue?vue&type=template&id=116593d2&scoped=true&ts=true"
import script from "./TestInstructionsStepOne.vue?vue&type=script&lang=ts"
export * from "./TestInstructionsStepOne.vue?vue&type=script&lang=ts"

import "./TestInstructionsStepOne.vue?vue&type=style&index=0&id=116593d2&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116593d2"]])

export default __exports__